import { ChangeDetectorRef } from '@angular/core';

export function deferViewUpdate(cdr: ChangeDetectorRef, update: () => void): void {
  queueMicrotask(() => {
    update();
    cdr.markForCheck();
  });
}
